import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import DataGridWrapper from '@/projects/syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { DataGrid, DateBox, DateRangeBox, NumberBox, Popup, SelectBox, TextBox } from 'devextreme-react';
import { paymentService } from '../services/payment-service';
import { vendorService } from '../../syncflow/services/vendor_supply_parameter-service';
import { SelectBoxTypes } from 'devextreme-react/cjs/select-box';
import { DateRangeBoxTypes } from 'devextreme-react/cjs/date-range-box';
import { Button } from 'devextreme-react/button';
import { invoiceService } from '../services/invoice-service';
import { TextBoxTypes } from 'devextreme-react/cjs/text-box';
import { NumberBoxTypes } from 'devextreme-react/cjs/number-box';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { DateBoxTypes } from 'devextreme-react/cjs/date-box';

function Balance() {
    const dateLabel = { 'aria-label': 'Date' };
    const { customerCode: routeSupplierCode } = useParams();
    const [customerCode, setSupplierCode] = useState<string | undefined>(routeSupplierCode);
    const [supplierValue, setSupplierValue] = useState<string | undefined>("");

    const [startDate, setStartDate] = useState<Date>(new Date());
    const [endDate, setEndDate] = useState<Date>(new Date());

    const [type, setType] = useState<string | null>(null);
    const [account, setAccount] = useState<any>();
    const dataGridRef = useRef<DataGrid>(null);

    const [queryParams, setQueryParams] = useState({
        customerCode: undefined as string | undefined,
        startDate: null as Date | null,
        endDate: null as Date | null,
        type: null as string | null
    });


    const store = useMemo(() => {
        if (!queryParams.customerCode) return null;

        return new CustomStore({
            key: ['invoiceOrPaymentNo', 'date', 'customerCode', 'invoicePdf', 'invoiceId'],
            useDefaultSearch: true,
            load: async () => {
                const data = await paymentService.getCustomerBalance(
                    queryParams.customerCode,
                    queryParams.startDate,
                    queryParams.endDate,
                    queryParams.type
                );
                return data.transactions;
            }
        });
    }, [queryParams]);

    const paymentStatusLookup = useMemo(() => {
        const uniqueCodes = Array.from(
            new Set(account?.transactions?.map((item: any) => item.paymentStatu).filter(Boolean))
        );

        return uniqueCodes.map(code => ({
            code,
            name: t('syncflow:lb_payment_status_' + code),
        }));
    }, [account, t]);


    const dxfield = {
        marginTop: "0px"
    };

    const fetchAccounts = async () => {

        if (!customerCode) return;

        const data = await paymentService.getCustomerBalance(customerCode, null, null, null);

        setAccount(data);
        dataGridRef.current?.instance.refresh();
    };

    const onQuery = useCallback(async () => {
        setQueryParams({
            customerCode,
            startDate,
            endDate,
            type
        });
        await fetchAccounts();
    }, [customerCode, startDate, endDate, type]);

    useEffect(() => {
        if (routeSupplierCode) {
            setSupplierCode(routeSupplierCode);
            setSupplierValue(routeSupplierCode);
            onQuery();
        }
    }, [routeSupplierCode]);

    const onValueChangedSupplier = (e: SelectBoxTypes.ValueChangedEvent) => {
        setSupplierCode(e.value);
        setSupplierValue(e.value);
    };

    const onValueChangedDate = (e: DateRangeBoxTypes.ValueChangedEvent) => {
        setStartDate(e.value?.[0] ?? null);
        setEndDate(e.value?.[1] ?? null);
    };

    const onValueChangedType = (e: SelectBoxTypes.ValueChangedEvent) => setType(e.value);

    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

    const supplierLookups = useMemo(() => new CustomStore(
        {
            load: paymentService.getCustomerLookup,
            byKey: async (key) => {
                var returnObject = null;
                if (key) {
                    debugger;
                    const objectsByID = (await paymentService.getCustomerLookup())
                    returnObject = objectsByID.length > 0 ? objectsByID.find((w: any) => w.code === key) : null;
                }
                return returnObject
            },
        }
    ), []);



    const typeLookups = [
        { code: "01", name: t("syncflow:lb_all_invoices") },
        { code: "02", name: t("syncflow:lb_paid_invoices") },
        { code: "03", name: t("syncflow:lb_unpaid_invoices") },
        { code: "04", name: t("syncflow:lb_unpaid_over_due_invoices") },
        { code: "05", name: t("syncflow:lb_unpaid_not_over_due_invoices") },
        { code: "06", name: t("syncflow:lb_all_payments") },
    ];

    const goToDownload = (id: number, fileName: string) => {
        invoiceService.getDownloadInvoicePdf(id, fileName);
    };

    const status_cell_render = (data: any) => t('syncflow:lb_payment_status_' + data.row.data.paymentStatu);
    const balance_amount_cell_render = (data: any) => {
        const value = data.row.data.amount;
        const cls = data.row.data.type === 'A'
            ? "text-success"
            : "text-danger";
        return <span className={`${cls} fw-bold text-hover-${cls.split('-')[1]} d-block fs-6`}>{value}</span>;
    };

    const onValueChangedStartDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        setStartDate(e.value);
    }, []);

    const onValueChangedEndDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        setEndDate(e.value);
    }, []);

    return (
        <>


            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <Button
                        text="Search"
                        type="default"
                        icon="refresh"
                        onClick={onQuery}
                    />
                </div>
            </div>

            <div className="row">
                <label className="col-lg-1 col-form-label fw-bold fs-6 required"> {t("syncflow:supplier")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="vendorLookups"
                                key='code'
                                dataSource={supplierLookups}
                                value={supplierValue}
                                valueExpr="code"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onValueChangedSupplier}
                                showClearButton={true}
                            />
                        </div>
                    </div>
                </div>

                <label className="col-lg-1 col-form-label fw-bold fs-6"> {t("syncflow:lb_type")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="vendorLookups"
                                items={typeLookups}
                                valueExpr="code"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onValueChangedType}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_start_date")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                defaultValue={startDate}
                                inputAttr={dateLabel}
                                type="date"
                                onValueChanged={onValueChangedStartDate}
                            />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_end_date")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                defaultValue={endDate}
                                inputAttr={dateLabel}
                                type="date"
                                onValueChanged={onValueChangedEndDate}
                            />
                        </div>
                    </div>
                </div>
            </div>


            <div className="card-body py-3">
                <div className="table-responsive">
                    <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                        <thead>
                            <tr className="fw-bold text-muted">
                                <th className="w-25px">
                                    <div className="form-check form-check-sm form-check-custom form-check-solid"></div>
                                </th>
                                <th className="min-w-120px">{t('syncflow:supplier')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_total_debit')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_total_payments')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_balance')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="form-check form-check-sm form-check-custom form-check-solid"></div>
                                </td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(account?.summary.supplierName)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(account?.summary != undefined ? "$" + account?.summary.totalReceivable : "")}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(account?.summary != undefined ? "$" + account?.summary.totalPaid : "")}</span></td>
                                <td><span className={(account?.summary.totalReceivable - account?.summary.totalPaid >= 0 ? "text-success fw-bold text-hover-success d-block fs-6" : "text-danger fw-bold text-hover-danger d-block fs-6")}>{(account?.summary != undefined ? "$" + (Math.abs(account?.summary.totalReceivable) - Math.abs(account?.summary.totalPaid)).toFixed(2) : "")}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    columnChooser={true}
                    showColumnLines={true}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: false,
                        updateMessageText: RemoveMessage('Resource'),
                    }}


                    columns={[
                        {
                            dataField: 'date',
                            caption: t('syncflow:lb_date'),
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'invoiceOrPaymentNo',
                            caption: t('syncflow:lb_invoice_no'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'amount',
                            caption: t('syncflow:lb_amount'),
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true },
                            cellRender: balance_amount_cell_render,
                        },
                        {
                            dataField: 'balance',
                            caption: t('syncflow:lb_balance'),
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },
                        {
                            dataField: 'dueDate',
                            caption: t('syncflow:lb_due_date'),
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'paymentStatu',
                            caption: t('syncflow:lb_order_status'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: status_cell_render,
                            lookup: {
                                dataSource: paymentStatusLookup,
                                valueExpr: 'code',
                                displayExpr: 'name',
                            },
                        },
                        {
                            dataField: 'lineBalance',
                            caption: t('syncflow:lb_remaining_payment'),
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },
                        // {
                        //     caption: "Pdf",
                        //     allowFiltering: false,
                        //     allowEditing: false,
                        //     cellRender: (data: any) => {
                        //         return (
                        //             <Button
                        //                 text="Download"
                        //                 type="default"
                        //                 icon='download'
                        //                 stylingMode="contained"
                        //                 onClick={() => goToDownload(data.key.invoiceId, data.key.invoicePdf)}
                        //             />
                        //         );
                        //     },
                        // }

                    ]}
                />
            </React.Fragment>

        </>


    )
}
export default Balance